import { Box, Grid, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { productFailManufacturing } from "../../../slices/manufacturer";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentCycle } from "../../../slices/common";
const initialValues = {
  comment: "",
};

const validationSchema = Yup.object().shape({
  comment: Yup.string()
    .max(500, "Maximum of 500 characters allowed")
    .required("Comment is required"),
});

const FailedManufacturingForm = (formProps) => {
  const currentCycle = useSelector(selectCurrentCycle)
  const dispatch = useDispatch();

  const handleSubmit = async (formData) => {
    try {
      const payload = {
        car_t_form_id: currentCycle?.car_t_manufacturing_form_id,
        subject_id: formProps?.subject_id,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
        qr_code_generated_id: formProps?.qr_code_generated_id,
        comment:
          formData?.comment || formData?.reason || "Manufacturing failed",
      };
      const res = await dispatch(productFailManufacturing(payload)).unwrap();
      if (res?.status == 200) {
        formProps.handleFormSubmit();
      }
    } catch (err) {
      console.error("Error failing manufacturing:", err);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          <Grid item xs={12}>
            <Typography
              variant="body1"
              sx={{
                color: "#000000",
                marginBottom: "8px",
                fontWeight: 500,
              }}
            >
              Comment <span className="MuiFormLabel-asterisk">&#42;</span>
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              name="comment"
              value={formik.values.comment}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.comment && Boolean(formik.errors.comment)}
              helperText={formik.touched.comment && formik.errors.comment}
              FormHelperTextProps={{
                sx: {
                  color: "#d32f2f",
                  fontWeight: 500,
                },
              }}
              placeholder="Add Comment"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "5px",
                  backgroundColor: "#f5f5f5",
                  "& fieldset": {
                    borderColor: "#d1d1d1",
                  },
                  "&:hover fieldset": {
                    borderColor: "#b0b0b0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1976d2",
                  },
                },
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                border: "1px solid rgb(235, 38, 81)",
                color: "#dc2626",
                backgroundColor: "white",
                textTransform: "none",
                fontSize: "0.875rem",
                fontWeight: "500",
                padding: "0.5rem 1rem",
                borderRadius: "0.25rem",
                minWidth: "12.5rem",
                "&:hover": {
                  backgroundColor: "rgb(255, 246, 246)",
                },
                "&:disabled": {
                  backgroundColor: "#d1d5db",
                  color: "#9ca3af",
                },
              }}
            >
              Fail Manufacturing
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default FailedManufacturingForm;
